<div class="report-heading d-flex align-items-center justify-content-between pr-4 pl-4">

  <h2 class="detail-heading"> {{ chartTitle | translate }} <span *ngIf="minDateOnwards">({{ minDateOnwards }})</span></h2>

  <app-dropdown-radio-selection *ngIf="showDropdown"
     [dropDownOption]="trendsDropdown" (dropDownValue)="trendsdropDownChange($event)"
     [showInvalueText]="false"
     [chartAnalysis]="true">
    </app-dropdown-radio-selection>

</div>

<div class="main-card-details">
  <ul>
    <li *ngFor="let item of chartOverviewData">
      <span class="overview-title">{{ item.label | translate }}</span>
      <ng-container *ngIf="item.label === 'reports.DateRange'; else otherValues">
        <span class="overview-value date-sec">
          <span>{{ item.value.split('to')[0] }}</span>
          <span class="date-separator">to</span>
          <span>{{ item.value.split('to')[1] }}</span>
        </span>
      </ng-container>

      <ng-template #otherValues>
        <span class="overview-value" *ngIf="item.value?.text !== undefined; else plainValue">
          {{ item.value.text | number : '1.0-1' }}
          <span class="symbol">{{ item.value.symbol }}</span>
        </span>
        <ng-template #plainValue>
          <span class="overview-value">{{ item.value }}</span>
        </ng-template>
      </ng-template>
    </li>
  </ul>
</div>

<ng-container *ngIf="priceChartData?.length && !chartLoader">
  <app-report-charts [height]="'350px'"
   [chartType]="chartView.analysisChart"
   [isBorder]="false" [name]="chartId"
   [staticZoning]="true"
   [data]="priceChartData"
   [label]="selectedChartId+(sqmLabel?' sqm':'')">
  </app-report-charts>
</ng-container>

<div *ngIf="chartLoader">
  <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
</div>